<div class="modal-header blue">
  <h4 class="modal-title">View Modify Enrollments</h4>
  <a
    href="javascript:void(0)"
    aria-label="javascript"
    class="modal-close-btn"
    (click)="close()"
  ></a>
</div>

<div class="modal-body">
  <form [formGroup]="groupEnrollmentForm" [class.loading]="isLoading">
    <div class="row">
      <div class="col-12">
        <div class="form-row mb-3">
          <div class="col">
            <div class="input-label">enrollment type</div>
            <div class="input-text">
              {{ groupEnrollment.enrollmentType }}
            </div>
          </div>
        </div>

        <div class="form-row mb-3">
          <div class="col-8">
            <div class="input-label">Group Name</div>
            <div class="input-text">
              {{ groupEnrollment.providerGroup?.name || 'N/A' }}
            </div>
          </div>

          <div class="col-4">
            <div class="input-label">Group ID</div>
            <div class="input-text">
              {{ groupEnrollment.id }}
            </div>
          </div>
        </div>

        <div class="form-row mb-3">
          <div class="col-6">
            <div class="input-label">NPI</div>
            <div class="input-text">
              {{ groupEnrollment.npi }}
            </div>
          </div>

          <div class="col-6">
            <div class="input-label">tax id</div>
            <div class="input-text">
              {{ groupEnrollment.taxId }}
            </div>
          </div>
        </div>

        <div class="form-row mb-3">
          <div class="col-6">
            <div class="input-label">status</div>
            <div class="input-wrap select">
              <select
                class="input"
                aria-label="enrollmentStatus"
                formControlName="enrollmentStatus"
              >
                <option value="null" selected="selected" disabled>
                  Select Status
                </option>
                <option
                  *ngFor="let status of statuses"
                  [value]="status.code"
                  title="{{ status.description }}"
                >
                  {{ status.description }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-6">
            <div class="w-134px">
              <div class="input-label">Followup Date</div>
              <div class="w-100">
                <datepicker formControlName="followUpDate"></datepicker>
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-3">
          <div class="col-6">
            <div class="input-label">Case Number</div>
            <input
              type="text"
              formControlName="caseNumber"
              placeholder="Enter Case Number"
              class="input"
              [class.is-invalid]="
                groupEnrollmentForm.get('caseNumber')?.touched &&
                groupEnrollmentForm.get('caseNumber')?.invalid
              "
            />

            <div
              class="invalid-feedback text-left"
              *ngIf="
                groupEnrollmentForm.get('caseNumber')?.invalid &&
                groupEnrollmentForm.get('caseNumber')?.touched
              "
            >
              <span
                *ngIf="groupEnrollmentForm.get('caseNumber')?.errors?.maxLength"
              >
                Maximum length is
                {{
                  groupEnrollmentForm.get('caseNumber')?.errors?.maxlength[
                    'requiredLength'
                  ]
                }}
                characters.
              </span>
            </div>
          </div>

          <div class="col-6">
            <div class="input-label">processor id</div>
            <input
              type="text"
              formControlName="processorId"
              placeholder="processor"
              class="input"
            />
          </div>
        </div>

        <div class="form-row mb-3">
          <div class="col-8">
            <div class="input-label">Payer Name</div>
            <input
              type="text"
              aria-label="payername"
              [disabled]="true"
              [value]="groupEnrollment.payer?.name || 'N/A'"
              class="input"
            />
          </div>

          <div class="col-4">
            <div class="input-label">Payer ID</div>
            <input
              type="text"
              aria-label="payerid"
              [disabled]="true"
              [value]="groupEnrollment.payerId"
              class="input"
            />
          </div>
        </div>

        <div class="form-row mb-3">
          <div class="col-6">
            <div class="input-label">Notes</div>

            <div class="input-wrap">
              <textarea
                rows="7"
                placeholder="Enter Notes"
                formControlName="actionNotes"
              ></textarea>
            </div>
            <div
              class="invalid-feedback text-left"
              *ngIf="
                groupEnrollmentForm.get('actionNotes')?.invalid &&
                groupEnrollmentForm.get('actionNotes')?.touched
              "
            >
              <span
                *ngIf="
                  groupEnrollmentForm.get('actionNotes')?.errors?.maxLength
                "
              >
                Maximum length is
                {{
                  groupEnrollmentForm.get('actionNotes')?.errors?.maxlength[
                    'requiredLength'
                  ]
                }}
                characters.
              </span>
            </div>
          </div>
          <div class="col-6">
            <div class="input-label">Message</div>

            <div class="input-wrap">
              <textarea
                rows="7"
                [class.is-invalid]="
                  groupEnrollmentForm.get('message')?.touched &&
                  groupEnrollmentForm.get('message')?.invalid
                "
                placeholder="Enter Message"
                formControlName="message"
              ></textarea>
            </div>
            <div
              class="invalid-feedback text-left"
              *ngIf="
                groupEnrollmentForm.get('message')?.invalid &&
                groupEnrollmentForm.get('message')?.touched
              "
            >
              <span
                *ngIf="groupEnrollmentForm.get('message')?.errors?.maxLength"
              >
                Maximum length is
                {{
                  groupEnrollmentForm.get('message')?.errors?.maxlength[
                    'requiredLength'
                  ]
                }}
                characters.
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form-row mb-3">
          <div class="col">
            <div class="input-label">Logs</div>
            <div
              class="standart-table-wrapper modal-table"
              *ngIf="logs?.length; else emptyLogs"
            >
              <table class="standart-table">
                <thead class="standart-table-header">
                  <tr>
                    <th>Status</th>
                    <th>Date</th>
                    <th>User</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let log of logs">
                    <tr>
                      <td>{{ log.status || 'N/A' }}</td>
                      <td>
                        {{
                          (log.updated | date: 'MM/dd/yyyy hh:mm a') || 'N/A'
                        }}
                      </td>
                      <td>{{ log.userName || 'N/A' }}</td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="form-row mb-3">
          <div class="col">
            <div *ngIf="selectedPayer && documents">
              <div class="input-label">documents</div>
              <div class="standart-card-outline">
                <div
                  class="standart-card-outline-body"
                  [class.documents]="documents.length"
                >
                  <ng-container *ngIf="documents?.length; else empty">
                    <div class="file" *ngFor="let item of documents">
                      <div class="file-icon">
                        <i class="fas fa-file-pdf"></i>
                      </div>
                      <a href="javascript:void(0);" (click)="download({ item })"
                        ><span class="file-name">{{ item }}</span></a
                      >
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-row mb-3">
          <div class="col-6">
            <div>
              <div class="input-label">Owner</div>
              <div class="input-text">
                {{ groupEnrollment.enrollmentOwner || 'N/A' }}
              </div>
            </div>
          </div>

          <div class="col-6">
            <button class="button-outline ml-auto" (click)="editNote()">
              Enrollment Instructions
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <p class="info">
    Last Modified by: {{ groupEnrollment.lastUpdatedBy }} on
    {{ groupEnrollment.dateLastDbUpdate | date: 'MM/dd/yy' }} at
    {{ groupEnrollment.dateLastDbUpdate | date: 'mediumTime' }}
  </p>
  <button
    type="submit"
    class="button ml-auto w-80px"
    [disabled]="isLoading"
    (click)="onSave()"
  >
    Save
  </button>
</div>

<ng-template #emptyLogs>
  <empty-state title="Logs Not Founded"> </empty-state>
</ng-template>

<ng-template #empty>
  <empty-state title="Documents Not Provided"> </empty-state>
</ng-template>

<ng-template #loading>
  <loader style="height: 80px"></loader>
</ng-template>
